import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MetaService } from '../meta.service';
@Component({
  selector: 'app-qone',
  templateUrl: './qone.component.html',
  styleUrls: ['./qone.component.scss']
})
export class QoneComponent implements OnInit {
  title = 'Property Management Software & CRM for Real Estate';
  constructor(
    private titleService: Title, 
    private metaService: MetaService,
    private meta: Meta
  ) { }


  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.meta.updateTag(
      { name: 'description', content: "Optimize property operations with our Property Management Software. Streamline tasks seamlessly with our Property Management System & user-friendly Property Management App." }
    );
    this.metaService.createCanonicalURL();
  }

}


 